export const defaultSetting = {
  range: { min: 0, max: 45 },
  price: 1,
  numberQuantity: 6,
  isDuplicate: true,
}
